module.exports = __webpack_public_path__ + "static/media/naka-itabashi-1.b72e964e.jpg";